import { VwoService } from './../../../../shared/services/vwo/vwo.service';
import { VariablesService } from './../../../../shared/services/variables/variables.service';
import { Component, Input, OnInit } from '@angular/core';
import { IFundraiser } from '../../../../fundraiser/models/fundraiser.model';

@Component({
  selector: 'app-amount-card',
  templateUrl: './amount-card.component.html',
  styleUrls: ['./amount-card.component.scss']
})
export class AmountCardComponent implements OnInit {

  @Input() public goal;
  @Input() public raised;
  @Input() public date;
  @Input() public supporters;
  @Input() public currency;
  @Input() public isFundraiserEnded;
  @Input() public fundraiser: IFundraiser;
  today = new Date();
  showRaisedAmt: boolean;
  counto;
  beneficiaryName;

  constructor(
    public variablesService: VariablesService,
    public vwoService: VwoService
  ) { }

  ngOnInit() {
    this.beneficiaryName = this.fundraiser?.beneficiaryname?.info_1.split(' ')[0];
    setTimeout(() => { this.showRaisedAmt = true; }, 0);
  }

  setAmount(raised: number) {
    return typeof raised !== 'number' ? false : true;
  }
}
